import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SarcasmScoreRangeFilter from '../../../shared-components/SarcasmScoreRangeFilter/SarcasmScoreRangeFilter';

const SARCASM_FILTER_BUTTON_LABEL = 'Sarcasm Score Range';

export class CommentSarcasmScoreRangeFilter extends Component {

  static propTypes = {
    minimumSarcasmScore: PropTypes.number.isRequired,
    maximumSarcasmScore: PropTypes.number.isRequired,
    setCommentsAndTweetsSarcasmScoreFilter: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isSarcasmScoreRangeFilter: true
    };
    this.wrapperRef = React.createRef();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  toggleSarcasmScoreRangeFilterIsActive= () => {  
    this.setState(prevState => {
      return { isSarcasmScoreRangeFilter: !prevState.isSarcasmScoreRangeFilter };
    });
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isCommentSentimentAndEmotionFilter: false });
    }
  }

  closeDropdownWindow = () => {
    this.setState({
      isSarcasmScoreRangeFilter: true,
    });
  }

  render() {
    const {
      isSarcasmScoreRangeFilter
    } = this.state;

    return ( 
      <div>
        <div
          className={`input-container-sarcasm-score-range ${isSarcasmScoreRangeFilter ? 'active' : ''}`}
          ref={this.wrapperRef}
        >
          <div
            className="sarcasm-score-range-dropdown"
            onClick={() => this.toggleSarcasmScoreRangeFilterIsActive()}
          >
            <div className='sarcasm-filter-placeholder'>{SARCASM_FILTER_BUTTON_LABEL}</div>
            <i className={`la la-${isSarcasmScoreRangeFilter ? 'minus' :'plus'}`} />
          </div>
        </div>
        {isSarcasmScoreRangeFilter && (
          <div className='sarcasm-score-range-filter-content'>
            <SarcasmScoreRangeFilter 
              minimumSarcasmScore={this.props.minimumSarcasmScore}
              maximumSarcasmScore={this.props.maximumSarcasmScore}
              setFeedModalSarcasmScoreFilter={this.props.setCommentsAndTweetsSarcasmScoreFilter}
              closeDropdownWindow={() => this.closeDropdownWindow()}
            />
          </div>
        )}
      </div>
    )
  }
}

export default CommentSarcasmScoreRangeFilter;


// WEBPACK FOOTER //
// ./src/features/home/components/comment-filter/CommentSarcasmScoreRangeFilter.js